<template>
  <v-app style="background-color: transparent !important; min-height: auto !important;">
    <div class="row">

      <div class="col-lg-3 col-md-4 mb-6">
        <div class="card card-custom border-0 shadow-sm rounded-xl overflow-hidden">
          <div class="card-body text-center p-6">
            <h5 class="font-weight-bolder mb-5 text-dark-75">Foto Profil</h5>
        <div class="row">
          <div class="col-md-12 col-lg-12 col-sm-12 mb-2">
            <div class="d-flex justify-content-center mb-5">
              <div class="image-input image-input-outline image-input-circle bg-light" style="width: 160px; height: 160px; border-radius: 50%; overflow: hidden; position: relative; border: 4px solid #ffffff; box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0,0,0,.05);">
                <!-- upload Preview -->
                <img
                  class="w-100 h-100"
                  style="object-fit: cover;"
                  :src="[uploadedImageUrl == '' ? form.photo_name : uploadedImageUrl]"
                  @load="onImageLoad()"
                  v-if="uploadMethod == 'upload'"
                >

                <!-- camera -->
                <div
                  v-if="uploadMethod == 'camera'"
                  class="mb-3"
                >
                  <vue-web-cam
                    ref="webcam"
                    :device-id="deviceId"
                    width="100%"
                    @started="onStarted"
                    @stopped="onStopped"
                    @error="onError"
                    @cameras="onCameras"
                    @camera-change="onCameraChange"
                    v-if="captureStatus == false"
                  />

                  <figure
                    class="figure"
                    v-else-if="captureStatus == true"
                  >
                    <img
                      :src="baseImg"
                      class="img-responsive doctor-entry-form__capture"
                    />
                  </figure>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex flex-column mt-4">
              <span class="text-muted font-weight-bold font-size-sm mb-3">
                Mode: <span class="text-primary">{{ uploadMethod == "upload" ? "Unggah File" : "Kamera" }}</span>
              </span>
              
              <div class="d-flex justify-content-center mb-3" style="gap: 8px;">
                <button
                  type="button"
                  class="btn btn-light-success font-weight-bolder btn-sm rounded-lg flex-fill"
                  @click="changeUploadBtn"
                  v-if="uploadMethod == 'upload'"
                >
                  <i class="fas fa-camera mr-1"></i> Kamera
                </button>
                <button
                  type="button"
                  class="btn btn-light-primary font-weight-bolder btn-sm rounded-lg flex-fill"
                  @click="changeUploadBtn"
                  v-if="uploadMethod == 'camera'"
                >
                  <i class="fas fa-upload mr-1"></i> Unggah
                </button>
                <button
                  class="btn btn-light-danger font-weight-bolder btn-sm rounded-lg flex-fill"
                  @click="resetImg"
                >
                  <i class="fas fa-undo mr-1"></i> Reset
                </button>
              </div>

              <!-- Camera specific controls -->
              <div v-if="uploadMethod == 'camera'" class="mt-2">
                <button
                  type="button"
                  class="btn btn-primary font-weight-bolder rounded-lg w-100"
                  v-if="captureStatus == false"
                  @click="onCapture"
                >
                  <i class="fas fa-dot-circle mr-1"></i> Ambil Foto
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>
        </div>
      </div>

      <div class="col-md">
        <b-form
          @submit.stop.prevent="formOnSubmit"
          enctype="multipart/form-data"
        >
          <b-alert
            v-if="validationMessages.length"
            show
            variant="danger"
            class="mb-5"
          >
            <strong>Data dokter belum dapat disimpan.</strong>
            <ul class="mb-0 mt-2 pl-5">
              <li
                v-for="message in validationMessages"
                :key="message"
              >
                {{ message }}
              </li>
            </ul>
          </b-alert>

          <div class="card card-custom border-0 shadow-sm rounded-xl mb-6">
            <div class="card-header bg-transparent border-0 pt-6 pb-0">
              <h5 class="card-title font-weight-bolder text-dark-75 mb-0">Informasi Dokter</h5>
            </div>
            <div class="card-body p-6 operational-form-grid">
          <!-- Input Name -->
          <b-form-group
            id="input-group-name"
            label="Nama:"
            label-for="input-name"
          >
            <b-form-input
              id="input-name"
              v-model="form.name"
              placeholder="Nama Lengkap"
              required
            ></b-form-input>
            <small class="text-danger">{{ error.name }}</small>
          </b-form-group>

          <!-- Input Poliklinik -->
          <b-form-group
            id="input-group-polyclinic"
            label="Poliklinik:"
            label-for="input-polyclinic"
          >
            <b-form-select
              id="input-polyclinic"
              class="doctor-polyclinic-select"
              v-model="form.polyclinic_id"
              :options="polyclinicOptions"
              :disabled="polyclinicsLoading"
              @focus="refreshPolyclinicsIfEmpty"
              required
            ></b-form-select>
            <small class="text-danger">{{ error.polyclinic_id }}</small>
            <small
              v-if="polyclinicsLoadFailed"
              class="d-block text-danger mt-1"
            >
              Data poliklinik gagal dimuat. Klik kolom ini untuk mencoba lagi.
            </small>
          </b-form-group>

          <!-- Input Sip -->
          <b-form-group
            id="input-group-sip"
            label="Nomor SIP:"
            label-for="input-sip"
          >
            <b-form-input
              id="input-sip"
              v-model="form.sip_number"
              placeholder="Nomor SIP"
              inputmode="numeric"
              required
            >
            </b-form-input>
            <small class="text-danger">{{ error.sip_number }}</small>
          </b-form-group>

          <b-form-group id="input-group-ktp">
            <label for="input-ktp"
              >NIK:</label
            >
            <b-form-input
              id="input-ktp"
              v-model="form.registration_number"
              placeholder="NIK"
            >
            </b-form-input>
            <small class="text-danger">{{ error.registration_number }}</small>
          </b-form-group>

          <!-- Input Sip Expired -->
          <b-form-group
            id="input-group-date"
            label="Masa Berlaku SIP:"
            label-for="input-date"
          >
            <v-dialog
              ref="dialog"
              v-model="datePickerPopUp"
              :return-value.sync="form.sip_exp"
              persistent
              width="350px"
            >
              <template v-slot:activator="{ on, attrs }">
                <b-form-input
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  id="input-trigger-datepicker"
                  v-model="form.sip_exp"
                  required
                >
                </b-form-input>
              </template>
              <v-date-picker
                v-if="datePickerPopUp"
                v-model="form.sip_exp"
                locale="id"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="datePickerPopUp = false"
                >Cancel</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(form.sip_exp)"
                >OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <small class="text-danger">{{ error.sip_exp }}</small>
          </b-form-group>

          <!-- Input Id Card -->
          <b-form-group
            id="input-group-id-card-number"
            label="Nomor ID Kartu:"
            label-for="input-id-card-number"
          >
            <b-form-input
              id="input-id-card-number"
              v-model="form.id_card_number"
              placeholder="ID Kartu"
              required
            ></b-form-input>
            <small class="text-danger">{{ error.id_card_number }}</small>
          </b-form-group>
            </div>
          </div>

          <div class="card card-custom border-0 shadow-sm rounded-xl mb-6">
            <div class="card-header bg-transparent border-0 pt-6 pb-0">
              <h5 class="card-title font-weight-bolder text-dark-75 mb-0">Informasi Akun</h5>
            </div>
            <div class="card-body p-6 operational-form-grid">
          <!-- Input Email -->
          <b-form-group id="input-group-email">
            <label for="input-email">Email:</label>
            <b-form-input
              id="input-email"
              v-model="form.email"
              type="email"
              placeholder="Email"
              required
            ></b-form-input>
            <small class="text-danger">{{ error.email }}</small>
          </b-form-group>

          <template v-if="password">
            <!-- Input Password -->
            <div class="form-group">
              <label for="password">Password:</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div
                    class="input-group-text"
                    @click="passwordIsVisible == 'password' ? passwordIsVisible = 'text' : passwordIsVisible = 'password' "
                  >
                    <div v-if="passwordIsVisible == 'password'">
                      <b-icon-eye-slash></b-icon-eye-slash>
                    </div>
                    <div v-if="passwordIsVisible == 'text'">
                      <b-icon-eye></b-icon-eye>
                    </div>
                  </div>
                </div>
                <input
                  :type="passwordIsVisible"
                  class="form-control"
                  placeholder="Password"
                  v-model="form.password"
                  id="input-password"
                  required
                >
              </div>
              <small class="text-danger">{{ error.password }}</small>
            </div>

            <!-- Input Password Confirmation -->
            <div class="form-group">
              <label for="password">Ulangi Password:</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div
                    class="input-group-text"
                    @click="confirmPasswordIsVisible == 'password' ? confirmPasswordIsVisible = 'text' : confirmPasswordIsVisible = 'password' "
                  >
                    <div v-if="confirmPasswordIsVisible == 'password'">
                      <b-icon-eye-slash></b-icon-eye-slash>
                    </div>
                    <div v-if="confirmPasswordIsVisible == 'text'">
                      <b-icon-eye></b-icon-eye>
                    </div>
                  </div>
                </div>
                <input
                  :type="confirmPasswordIsVisible"
                  class="form-control"
                  placeholder="Ulangi Password"
                  v-model="form.password_confirmation"
                  id="input-password-confirmation"
                  required
                >
              </div>
              <small class="text-danger">{{ error.password_confirmation }}</small>
            </div>
          </template>
            </div>
          </div>

          <div class="card card-custom border-0 shadow-sm rounded-xl mb-6">
            <div class="card-header bg-transparent border-0 pt-6 pb-0">
              <h5 class="card-title font-weight-bolder text-dark-75 mb-0">Kontak</h5>
            </div>
            <div class="card-body p-6 operational-form-grid">
          <!-- Input Phone -->
          <b-form-group
            id="input-group-mobile-phone"
            label="Nomor Handphone:"
            label-for="input-mobile-phone"
          >
            <b-form-input
              id="input-mobile-phone"
              v-model="form.mobile_phone"
              placeholder="Nomor Handphone"
              inputmode="numeric"
              required
            ></b-form-input>
            <small class="text-danger">{{ error.mobile_phone }}</small>
          </b-form-group>

          <!-- Input Telephone -->
          <b-form-group id="input-group-phone">
            <label for="input-phone">Telepon: <em class="text-muted">opsional</em></label>
            <b-form-input
              id="input-phone"
              v-model="form.phone"
              placeholder="Telepon"
            ></b-form-input>
            <small class="text-danger">{{ error.phone }}</small>
          </b-form-group>

          <!-- Input Address -->
          <RegionAddressFields :form="form" />
          <b-form-group id="input-group-address" class="operational-form-grid__wide">
            <label for="input-address">Alamat: <em class="text-muted">opsional</em></label>
            <b-form-textarea
              id="input-address"
              v-model="form.address"
              placeholder="Alamat Lengkap"
              rows="4"
              max-rows="8"
            ></b-form-textarea>
            <small class="text-danger">{{ error.address }}</small>
          </b-form-group>

          <!-- Profile Image -->
          <b-form-group id="input-group-image" class="operational-form-grid__wide">
            <label for="input-image">Foto Profil: <em class="text-muted">opsional</em></label>
            <clinical-file-upload
              v-model="form.photo"
              accept="image/jpeg,image/png,image/webp"
              browse-text="Pilih file"
              placeholder="Belum ada foto dipilih"
              drop-placeholder="Lepaskan foto di sini"
              @change="onFileUpload"
            ></clinical-file-upload>
                        <small class="text-danger">{{ error.photo }}</small>
          </b-form-group>
            </div>
          </div>

          <!-- Buttons -->
          <div class="d-flex justify-content-end mb-5">
            <b-button
              type="submit"
              variant="primary"
            >Simpan</b-button>
            <b-button
              class="ml-2"
              variant="light"
              @click="$router.push('/doctor/list')"
            >
              Batal
            </b-button>
            <b-button
              class="ml-2"
              variant="light-danger"
              type="reset"
            >
              Reset
            </b-button>
          </div>
        </b-form>
      </div>

    </div>
  </v-app>
</template>

<script>

import module from '@/core/modules/CrudModule.js'
import validation from '@/core/modules/ValidationModule.js'
import { WebCam } from 'vue-web-cam'
import RegionAddressFields from '@/component/general/RegionAddressFields.vue'

export default {

  props: {
    form: Object,
    route: String,
    password: Boolean
  },

  components: {
    "vue-web-cam": WebCam,
    RegionAddressFields
  },

  data() {
    return {
      // Error
      error: {
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        sip_number: "",
        sip_exp: "",
        id_card_number: "",
        registration_number: "",
        mobile_phone: "",
        phone: "",
        address: "",
        polyclinic_id: "",
        photo: "",
        form: ""
      },
      datePickerPopUp: false,
      // Other
      polyclinics: [],
      polyclinicsLoading: false,
      polyclinicsLoadFailed: false,
      imgLoaded: false,
      uploadedImageUrl: '',
      uploadMethod: 'upload',
      passwordIsVisible: 'password',
      confirmPasswordIsVisible: 'password',
      // Camera
      baseImg: null,
      camera: null,
      deviceId: null,
      devices: [],
      img: null,
      captureStatus: false,
    }
  },

  computed: {
    validationMessages() {
      return [...new Set(
        Object.values(this.error).filter(message => Boolean(message))
      )]
    },

    polyclinicOptions() {
      return [
        {
          text: this.polyclinicPlaceholder,
          value: null,
          disabled: true
        },
        ...this.polyclinics
      ]
    },

    polyclinicPlaceholder() {
      if (this.polyclinicsLoading) {
        return 'Memuat poliklinik...'
      }

      if (this.polyclinicsLoadFailed) {
        return 'Gagal memuat poliklinik'
      }

      return this.polyclinics.length > 0
        ? 'Pilih Poliklinik'
        : 'Belum ada poliklinik'
    },

    device() {
      return this.devices.find(device => device.deviceId === this.deviceId)
    }
  },

  methods: {

    async refreshPolyclinicsIfEmpty() {
      if (!this.polyclinicsLoading && this.polyclinics.length === 0) {
        await this.getPolyclinics()
      }
    },

    onImageLoad() {
      this.imgLoaded = true
    },

    onFileUpload(evt) {
      this.uploadedImageUrl = URL.createObjectURL(evt.target.files[0])
      this.form.photo = evt.target.files[0]
    },

    resetImg() {
      if (this.uploadedImageUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.uploadedImageUrl)
      }

      this.uploadedImageUrl = ''
      this.form.photo = []
      this.img = null
      this.baseImg = null
      this.captureStatus = false

      if (this.uploadMethod === 'camera' && this.$refs.webcam) {
        this.onStart()
      }
    },

    oncancel() {
      if (this.purpose == 'master') {
        this.onStop()
        $router.push('/patient/list')
      } else if (this.purpose == 'modal') {
        this.onStop()
        $bvModal.hide('modal-patient')
      }
    },

    changeUploadBtn() {
      if (this.uploadMethod == 'upload') {
        this.uploadMethod = 'camera'
        setTimeout(() => {
          this.onStart()
        }, 4000)
      } else {
        this.uploadMethod = 'upload'
      }
    },

    // camera method
    onCapture() {
      this.baseImg = this.$refs.webcam.capture();
      this.img = this.dataURItoBlob(this.baseImg)
      this.captureStatus = true
      this.onStop()

    },
    onStarted(stream) {
      console.log("On Started Event", stream);
    },
    onStopped(stream) {
      console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onPause() {
      this.$refs.webcam.pause();
    },
    onResume() {
      this.$refs.webcam.resume();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      console.log("On Camera Change Event", deviceId);
    },

    // convert base64 to image
    dataURItoBlob(dataURI) {
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
      else
        byteString = unescape(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {
        type: mimeString
      });
    },

    async getPolyclinics() {
      this.polyclinicsLoading = true
      this.polyclinicsLoadFailed = false

      try {
        // Use the same request path as the Polyclinic list page. This keeps the
        // active tenant headers and the API response shape consistent.
        const response = await module.paginate(
          'polyclinics',
          '?page=1&page_size=1000'
        )
        const items = response && Array.isArray(response.data)
          ? response.data
          : []

        this.polyclinics = items.map(item => ({
          text: item.name,
          value: item.id
        }))
        this.polyclinicsLoadFailed = items.length === 0
      } catch (error) {
        this.polyclinics = []
        this.polyclinicsLoadFailed = true
      } finally {
        this.polyclinicsLoading = false
      }
    },

    async formOnSubmit() {
      let formData = new FormData()
      if (this.img != null) {
        this.form.photo = this.img
      }

      const optionalFields = ['phone', 'address', 'registration_number']
      for (const [key, value] of Object.entries(this.form)) {
        if (key === 'photo_name') {
          continue
        }

        if (key === 'photo') {
          if (value instanceof File || value instanceof Blob) {
            formData.append(key, value)
          }
          continue
        }

        if (
          optionalFields.includes(key) &&
          (value === '' || value === null || value === undefined)
        ) {
          continue
        }

        const normalizedValue =
          typeof value === 'string' &&
          key !== 'password' &&
          key !== 'password_confirmation'
            ? value.trim()
            : value

        formData.append(key, normalizedValue)
      }
      // Make Request
      let response = await module.submit(formData, this.route)
      // Check Response
      if (response.state == 'error') {
        // Validation Error
        const errors =
          response.error && response.error.errors
            ? response.error.errors
            : {
                form: ['Data dokter gagal disimpan. Periksa kembali isian form.']
              }

        this.error = validation.setValidationError(this.error, errors)
        this.$nextTick(() => {
          const firstError = this.$el.querySelector('.text-danger:not(:empty)')
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, 'success')
        this.$router.push('/doctor/list')
      }
    }

  },

  watch: {
    camera: function (id) {
      this.deviceId = id
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      }
    }
  },

  mounted() {
    // Get Polyclinics
    this.getPolyclinics()
  }

}
</script>

<style>
.doctor-polyclinic-select.custom-select {
  padding-right: 44px !important;
  color: #1f3147 !important;
  background-color: #ffffff !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8' viewBox='0 0 14 8'%3E%3Cpath fill='%2314608f' d='M1.4.6 7 5.9 12.6.6 14 2 7 8 0 2z'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 16px center !important;
  background-size: 14px 8px !important;
  -webkit-text-fill-color: #1f3147 !important;
  opacity: 1 !important;
}

.doctor-polyclinic-select.custom-select:disabled {
  color: #60758d !important;
  background-color: #f2f5f8 !important;
  -webkit-text-fill-color: #60758d !important;
  opacity: 1 !important;
}

.doctor-polyclinic-select.custom-select option {
  color: #1f3147;
  background: #ffffff;
}
</style>
